import { MapMarkerId, RouteWaypoint } from "./types";

export function isWaypointMarkerId(markerId: MapMarkerId): markerId is `waypoint-${string}` {
  return markerId.startsWith("waypoint-");
}

export function getWaypointIdFromMarker(markerId: MapMarkerId): string | null {
  if (!isWaypointMarkerId(markerId)) return null;
  return markerId.slice("waypoint-".length);
}

export function toWaypointMarkerId(waypointId: string): MapMarkerId {
  return `waypoint-${waypointId}`;
}

export function formatWaypointLabel(template: string, index: number): string {
  return template.replace("{index}", String(index));
}

export function createEmptyWaypoint(id: string): RouteWaypoint {
  return { id, address: "", coords: null };
}

export function createWaypointId(): string {
  return `wp-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}
